import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Locale } from 'date-fns';

import enTranslations from './locales/en.json';
import frTranslations from './locales/fr.json';
import deTranslations from './locales/de.json';
import esTranslations from './locales/es.json';
import ptTranslations from './locales/pt.json';

// Import `date-fns` locales
import { enUS, fr, de, es, pt } from 'date-fns/locale';

// Supported languages
const supportedLanguages = ['en', 'fr', 'de', 'es', 'pt'];

// Mapping `i18n` languages to `date-fns` locales
const localeMap: Record<string, Locale> = {
  en: enUS,
  fr,
  de,
  es,
  pt,
};

const getUserLanguage = () => {
  // Check for a saved language preference
  const savedLanguage = localStorage.getItem('userLanguage');
  if (savedLanguage && supportedLanguages.includes(savedLanguage)) {
    console.log('Using saved language from localStorage:', savedLanguage);
    return savedLanguage;
  }

  // Determine browser language
  const browserLanguage = navigator.language.split('-')[0];
  if (browserLanguage && supportedLanguages.includes(browserLanguage)) {
    console.log('Using browser language:', browserLanguage);
    return browserLanguage;
  }

  // Fallback to default
  console.log('Fallback to default language: en');
  return 'en';
};

// Initialize i18n
i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslations },
    fr: { translation: frTranslations },
    de: { translation: deTranslations },
    es: { translation: esTranslations },
    pt: { translation: ptTranslations },
  },
  lng: getUserLanguage(),
  fallbackLng: 'en', // Default fallback language
  interpolation: {
    escapeValue: false, // React already escapes by default
  },
});

// Export the locale map for use in other files
export const getLocale = (): Locale => {
  const currentLanguage = i18n.language || 'en'; // Fallback to English
  return localeMap[currentLanguage] || enUS; // Fallback to English locale
};

export default i18n;
